export enum RentalApplicationTypeEnum {
  Registration = 'Registration',
  AgencyChange = 'AgencyChange',
}

export const rentalApplicationTypeMap: Record<RentalApplicationTypeEnum, string> = {
  [RentalApplicationTypeEnum.Registration]: 'Registration',
  [RentalApplicationTypeEnum.AgencyChange]: 'Agent change',
};
